export default __webpack_public_path__ + "static/media/papper-bonus.ce67ca5e.png";